import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { removeActionTypes }    from 'Utils/ReducerUtility';
import { IAppUserState }        from 'Redux/Slices/AppUser/AppUserSlice';
import { TAppUserOrganisation } from 'Domain/Repositories/AppUserRepository/AppUserRepository';

export const assignAppUserOrganisationRequest = (state: Draft<IAppUserState>, { type }: PayloadAction<{ userId: string, organisationId: string, userRole?: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const assignAppUserOrganisationSuccess = (state: Draft<IAppUserState>, { type, payload }: PayloadAction<{ organisations: TAppUserOrganisation[] }>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.organisations = payload.organisations;
};

export const assignAppUserOrganisationFailure = (state: Draft<IAppUserState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
